module.exports = __webpack_public_path__ + "img/b.d2a0c015.png";